
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true,\"url\":true,\"alias\":{\"fonts\":\"..fonts\"}}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-6bfd8baa\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ListaDeSolicitacoes.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ListaDeSolicitacoes.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-6bfd8baa\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ListaDeSolicitacoes.vue"),
  /* scopeId */
  "data-v-6bfd8baa",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/controle-de-solicitacoes/ListaDeSolicitacoes.vue
// module id = 1037
// module chunks = 1